import BaseComponent from '@js/BaseComponent'

/**
 * Base class for links with decorators
 *
 * @extends BaseComponent
 */
export default class DecoratedLink extends BaseComponent {
    constructor(element, {
        iconName            = undefined,
        iconStyle           = 'fa-solid',
        srMessage           = undefined,
        classSuffix         = undefined,
        iconPositionLeft    = false
    } = {}) {
        super(element)

        if (sir.isEditor) return

        if (iconName) {
            const icon = document.createElement('i')
            icon.classList.add('decorated-link-icon')
            icon.ariaHidden = true

            if (classSuffix) {
                icon.classList.add(`decorated-link-icon--${classSuffix}`)
            }

            if (iconName) {
                icon.classList.add(iconName)
            }

            if (iconStyle) {
                icon.classList.add(iconStyle)
            }

            if (iconPositionLeft === true) {
                icon.classList.add('decorated-link-icon--left')
                element.prepend(icon)
            } else {
                icon.classList.add('decorated-link-icon--right')
                element.append(icon)
            }
        }

        if (srMessage) {
            const srText = document.createElement('span')
            srText.classList.add('sr-only')
            srText.innerHTML = `, ${srMessage}`
            element.appendChild(srText)
        }
    }
}
